import styles from '@/styles/ChatWindow.module.scss';

const TypingIndicator = () => {
  return (
    <div className={styles.typingIndicator}>
      <div className={styles.dots}>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </div>
    </div>
  );
};

export default TypingIndicator;
